import request from '@/utils/request'

export function create(data) {

  return request({
    url: '/nationalityCode/create',
    method: 'POST',
    data})
}

   

export function createBatch(data) {

  return request({
    url: '/nationalityCode/create/batch',
    method: 'POST',
    data})
}

   

export function deleteById(data) {

  return request({
    url: '/nationalityCode/deleteById',
    method: 'POST',
    data})
}

   

export function deleteByIds(data) {

  return request({
    url: '/nationalityCode/deleteByIds',
    method: 'POST',
    data})
}

   

export function getById(params) {

  return request({
    url: '/nationalityCode/getById',
    method: 'GET',
    params})
}

   

export function getByIds(params) {

  return request({
    url: '/nationalityCode/getByIds',
    method: 'GET',
    params})
}

   

export function list(params) {

  return request({
    url: '/nationalityCode/list',
    method: 'GET',
    params})
}

   

export function update(data) {

  return request({
    url: '/nationalityCode/update',
    method: 'POST',
    data})
}

   

export function updateBatch(data) {

  return request({
    url: '/nationalityCode/update/batch',
    method: 'POST',
    data})
}

   